import moduleId from './module-id';

const maxRules = 1e10;

export interface CustomJssGenerateIdOptions {
  minify?: boolean;
}

export interface CustomJssRule {
  key: string;
}

export interface CustomJssSheet {
  options: {
    classNamePrefix?: string;
    jss: {
      id?: string | number | null;
    };
  };
}

export type CustomJssGenerateId = (rule: CustomJssRule, sheet?: CustomJssSheet | null) => string;

// Customize createGenerateId function for jss setup
// Remove $ in prefix to resolve jss prefix with $ sign issue
// Issue: When prefix contains $, the nested style case will lose $ thus leads to style issue
export const createGenerateId = (options: CustomJssGenerateIdOptions = {}): CustomJssGenerateId => {
  let ruleCounter = 0;

  return (rule: CustomJssRule, sheet?: CustomJssSheet | null) => {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      console.warn(`[JSS] You might have a memory leak. Rule counter is at ${ruleCounter}.`);
    }

    let jssId = '';
    let prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }
      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return `${prefix || 'c'}${moduleId}${jssId}${ruleCounter}`.replace(/\$/g, ''); // remove generated $ sign
    }

    return `${prefix + rule.key}-${moduleId}${jssId ? `-${jssId}` : ''}-${ruleCounter}`.replace(/\$/g, ''); // remove generated $ sign
  };
};
